/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, Status, getState, showModal, arrayFrom, Flyout } from '../twd'


export default () => {
    const {status, count} = useAlerts(0)

    return <Flyout
        disabled={status===Status.LOADING}
        className='btn btn-link'
        dataName='alerts-link'
        label={`Alerts ${count>0 ? `(${count})` : ''}`}
        html={DISCLAIMER}
        trigger={['hover']}
        onClick={(e) => showModal('alerts', { source:e.target, })}
        showIcon={false}
        placement='bottom'
    />
}

const Last = getState('header.alerts', {
    ts: 0,
    alerts: []
})

export const useAlerts = () => {
    const [ts] = React.useState(Last.value.ts)
    const [status, setStatus] = React.useState(Status.LOADING)
    const [count, setCount] = React.useState(0)

    const lastAbort = React.useRef()

    React.useEffect(() => {
        if (Last.value.ts > ts) return

        ;(async () => {
            setStatus(Status.LOADING)

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let {data:hData, abort:hAbort} = ajax({
                    url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldingsAlerts',
                    method: 'GET'
                })
                lastAbort.current = hAbort
                let alerts = getHoldingAlerts(await hData || {})
                lastAbort.current = null

                let n = alerts.length
                setCount(n)

                Last.set({
                    ts: Date.now(),
                    alerts
                })

                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

        return () => {
            if (lastAbort.current) {
                lastAbort.current()
            }
        }
    }, [ts])

    // React.useEffect(() => {
    //     let subId = subscribe('order_status.header_use_alerts',
    //         bufferedFn(() => {
    //             setTs(Date.now())
    //         }))
    //     return () => { unsubscribe(subId) }
    // },[])

    return {
        status, count,
    }
}



const getHoldingAlerts = ({allCusipEvents}) => {
    let rs = arrayFrom(allCusipEvents)
    let m = rs.reduce( (x, r) => {
        let h = `${r.acctNo} ${r.cusip} ${r.alertDate} ${r.alertDescription}`
        if (x[h]) {
            x[h].qty += r.qty
        } else {
            x[h] = r
        }
        return x
    }, {})
    return Object.values(m).sort((a,b) => {
        let x = new Date(a.alertDate)
        let y = new Date(b.alertDate)
        return y - x
    })
}

const DISCLAIMER = `
    <p><b><u>Click the Alerts link (above) to view your alert listings</u></b></p>

    <p><b>Did you know?</b><br/>
    You are automatically enrolled to receive bond alerts for your
    fixed income positions. These include, but are not limited to,
    Moody's and S&P rating change events, call and redemption
    events, market price change events and material events
    </p>

    <p><b>Looking for more?</b><br/>
    E*Trade also provides clients access to new issue bond
    alerts on a subscription basis. If you are interested in
    receiving notifications for new issues, please
    <a href='#'
        data-name="sign-up-link"
        style="cursor:pointer"
        onClick="twd.openWindow('https://us.etrade.com/e/t/alerts/setnewissuealerts')">sign-up here</a>
    </p>
`


// WEBPACK FOOTER //
// ./src/header/alerts.js